<template>
  <div class="informationType">
    <div class="informationTab typeTab">
      <button
        v-for="(type, index) in types"
        :key="index"
        :data-type="type.id"
        type="button"
        class="btnTab"
        :class="{active: isActive(type.id)}"
        @click="changeType(type.id)">
        {{ type.name }}
      </button>
    </div>
    <div class="contentsTitle colorGrey2">후원의집 업종별 분류
      <div class="listTotal">총 <span class="bold colorPrimary2">{{houseCount}}</span>개의 후원의집이 있습니다</div>
    </div>
    <div v-if="list.length" class="gridList houseList">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item">
          <router-link :to="{ name: 'informationDetail', params: {id: item.tr_seq} }">
            <div class="img" :style="item.orgfile && {backgroundImage: `url('https://house.hyundai-motorsfc.com/UpData/introduce/${item.orgfile}')`}">
              <div v-if="!item.orgfile" class="title">{{ item.company }}</div>
            </div>
            <div class="title">{{ item.company }}</div>
            <div class="type">{{ item.company_gbn_txt }}</div>
            <div class="area">{{ item.newaddr }}</div>
          </router-link>
          <div class="tel">
            <a :href="`tel:${item.tel}`">{{ item.tel }}</a>
          </div>
      </div>
    </div>
    <div v-else class="noListData">데이터가 없습니다</div>
    <Pagination v-bind:total="houseCount" v-bind:pageDisplayCount="pageCount" @onChange="pageChange" />
    <ListFilter :types="searchTypes" :reset="searchReset" @onSearch="searchList" />
  </div>
</template>

<script>
import Pagination from '@/components/Common/Pagination'
import ListFilter from '@/components/Common/ListFilter'
import {companyGbnCode, companyGbnStr, isEmpty, telHyphen} from '@/lib';
import http from '@/api';

export default {
  name: 'InformationType',
  components: {
    Pagination,
    ListFilter
  },
  computed: {
    /*filteredList () {
      const type = this.$route.params.type;
      return this.list.filter(x => {
        return type === 'all' ? x : x.type === type
      })
    }*/
  },
  created () {
    this.$store.commit('setSubTopData', {
      title: '업종별 분류',
      desc: '전북 후원의집 소개합니다.'
    })
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      typeCode: this.$route.params.type,
      pageNum: 1,
      houseCount: 0,
      pageCount: 0,
      types: [
        {
          id: 'all',
          name: '전체'
        },
        {
          id: 'food',
          name: '요식업'
        },
        {
          id: 'medical',
          name: '의료업'
        },
        {
          id: 'life',
          name: '생활'
        },
        {
          id: 'hyundaicar',
          name: '현대차'
        }
      ],
      list: [],
      searchTypes: [
        {
          type: 'company',
          name: '회사'
        }
      ],
      searchpart: '',
      searchtext: '',
      searchReset: false,
    }
  },
  watch: {
    $route(to, form) {
      this.typeCode = to.params.type;
      this.searchtext = '';
      this.searchReset = true;
      this.pageNum = 1;
      this.houseListCalls();
    }
  },
  methods: {
    async init () {
      this.houseListCalls();
    },
    isActive (type) {
      return type === this.$route.params.type
    },
    changeType (type) {
      if (!this.isActive(type)) {
        this.$router.push({
          params: {
            type: type
          }
        })
      }
    },
    pageChange (page) {
      this.pageNum = page;
      this.houseListCalls();
    },
    searchList (data) {
      this.searchpart = data.type
      this.searchtext = data.word;

      this.houseListCalls('search');
    },
    houseListCalls(key) {
      let url = `/main/house?page=${this.pageNum}`;

      // 업종별
      if (isEmpty(this.searchtext) && !isEmpty(this.typeCode)){
        let type = companyGbnCode(this.typeCode);
        url += `&searchpart=company_gbn&searchtext=${type}`;
      }

      // 검색
      if (!isEmpty(this.searchtext)){
        url += `&searchpart=${this.searchpart}&searchtext=${this.searchtext}`;
      }

      http.get(url)
        .then(res => {
          let obj = res.data.data;
          this.houseCount = res.data.total;
          this.pageCount = res.data.per_page;

          Object.entries(obj).forEach(([, value]) => {
            if(!isEmpty(value.tel) && !value.tel.includes('-')) {
              value.tel = telHyphen(value.tel)
            }

            value.company_gbn_txt = companyGbnStr(value.company_gbn);
          });

          this.list = obj;
          this.searchReset = false;
        });
    }
  }
}
</script>
